import { computed, ref } from "vue";
import { defineStore } from "pinia";

export const useRoutingStore = defineStore("routing", () => {
  // State
  const _currentRouteIsCancelled = ref<boolean>(false);

  // Getters
  const currentRouteIsCancelled = computed(
    () => _currentRouteIsCancelled.value,
  );

  // Actions
  const setCurrentRouteAsCancelled = () => {
    _currentRouteIsCancelled.value = true;
  };

  const clearCurrentRouteCancelled = () => {
    _currentRouteIsCancelled.value = false;
  };

  return {
    currentRouteIsCancelled,
    setCurrentRouteAsCancelled,
    clearCurrentRouteCancelled,
  };
});
